export const DEPOSIT_SURVEY_STATUS_KEY: string = "deposit_survey_status";
